import { I18n } from '@calendly/i18n'
import { createSelector } from 'reselect'

const workflowBuilderSelector = ({ workflows: { builder } }) => builder

export const workflowSelector = createSelector(
  workflowBuilderSelector,
  ({ workflow }) => ({
    ...workflow,
    name: workflow.name === undefined ? I18n.t('publisher.workflows.builder_form.default_workflow_name') : workflow.name
  })
)

const eventTypesSelector = createSelector(
  workflowSelector,
  ({ event_types: eventTypes }) => eventTypes || []
)

export const eventTypeIdsSelector = createSelector(
  workflowSelector,
  ({ event_type_ids: eventTypeIds }) => eventTypeIds || []
)

export const sharedEventTypeSelectedSelector = createSelector(
  eventTypesSelector,
  eventTypeIdsSelector,
  (eventTypes, selectedIds) => (
    eventTypes.filter(({ id }) => selectedIds.includes(id)).some(({ shared }) => shared)
  )
)

const workflowRuleSelector = createSelector(
  workflowSelector,
  ({ workflow_rule: workflowRule }) => workflowRule
)

const workflowTypeSelector = createSelector(
  workflowSelector,
  ({ type }) => type
)

const workflowRuleEventNameSelector = createSelector(
  workflowRuleSelector,
  (rule) => rule.event_name
)
const triggerTypeSelector = createSelector(
  workflowRuleSelector,
  (rule) => rule.trigger_type
)

export const combinedTriggerTypeSelector = createSelector(
  workflowTypeSelector,
  triggerTypeSelector,
  workflowRuleEventNameSelector,
  (...props) => props.join('.')
)

export const workflowRuleTimeValueSelector = createSelector(
  workflowRuleSelector,
  (rule) => rule.time_value
)

export const workflowRuleTimeUnitsSelector = createSelector(
  workflowRuleSelector,
  (rule) => rule.time_units
)

export const workflowLoadingStateSelector = createSelector(workflowBuilderSelector,
  ({ workflowLoadingState }) => workflowLoadingState)

export const workflowRequestErrorSelector = createSelector(workflowBuilderSelector,
  ({ error }) => error)
